import { render, staticRenderFns } from "./Lesson.vue?vue&type=template&id=352a000b&"
import script from "./Lesson.vue?vue&type=script&lang=ts&"
export * from "./Lesson.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports